"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CODIGO_RELATORIO_PV_SEM_PV_ABERTO = exports.FORMATOS_RELATORIO_PV = exports.SECOES_RELATORIO_PV = void 0;
exports.SECOES_RELATORIO_PV = ['SALDOS', 'ETAPA', 'PREVISAO', 'PRECOS'];
exports.FORMATOS_RELATORIO_PV = ['PDF', 'XLSX'];
/** Codigo de erro 409 quando o cliente nao tem PV em aberto e nao se pediu concluidos. */
exports.CODIGO_RELATORIO_PV_SEM_PV_ABERTO = 'SEM_PV_ABERTO';
//# sourceMappingURL=vendas-relatorio.js.map